import {BaseService} from '../baseService.js';

/* 
 * Handles interaction with the tch account api
 */
export class ReferralService extends BaseService {

	constructor() {	
		super();
	}
	
	async getReferrals(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}		
		var data = await this.makeGETRequest('/api/resource/referrals' + params);		
		return data;		
	}
	
	async getReferral(referralCode) {
		var data = await this.makeGETRequest('/api/resource/referrals/' + referralCode);		
		return data;		
	}
	
	async saveReferral(referral, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/referrals/' + referral.referralCode, referral);
		} else {
			saved = await this.makePOSTRequest('/api/resource/referrals', referral);
		}
		return saved;		
	}	
	
	async deleteReferral(referralCode) {
		var data = await this.makeDELETERequest('/api/resource/referrals/' + referralCode);		
		return data;		
	}		
	
	async activateReferral(referralCode) {
		var data = await this.makePUTRequest('/api/resource/referrals/' + referralCode + '/activate');		
		return data;		
	}	
	
	async getPayments(referralCode) {
		var data = await this.makeGETRequest('/api/resource/referrals/' + referralCode + '/payments');		
		return data;		
	}
	
	async recordPayment(referralPayment) {
		var saved = await this.makePOSTRequest('/api/resource/referrals/' + referralPayment.referralCode + '/payments', referralPayment);		
		return saved;		
	}	
	
	async getBalanceHistory(referralCode) {
		var data = await this.makeGETRequest('/api/resource/referrals/' + referralCode + '/balance-history');		
		return data;		
	}	
	
	async getBalanceHistoryCurrent(referralCode) {
		var data = await this.makeGETRequest('/api/resource/referrals/' + referralCode + '/balance-history/current');		
		return data;		
	}
	
	async getBalanceHistoryDetails(referralCode, referralBalanceId) {
		var data = await this.makeGETRequest('/api/resource/referrals/' + referralCode + '/balance-history/' + referralBalanceId + '/details');		
		return data;		
	}	
	
	async getReferralPrograms(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}		
		var data = await this.makeGETRequest('/api/resource/referral-programs' + params);		
		return data;		
	}
	
	async getReferralProgram(referralProgramCode) {
		var data = await this.makeGETRequest('/api/resource/referral-programs/' + referralProgramCode);		
		return data;		
	}
	
	async saveReferralProgram(referralProgramModel, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/referral-programs/' + referralProgramModel.referralProgram.referralProgramCode, referralProgramModel);
		} else {
			saved = await this.makePOSTRequest('/api/resource/referral-programs', referralProgramModel);
		}
		return saved;		
	}	
	
	async deleteReferralProgram(referralProgramCode) {
		var data = await this.makeDELETERequest('/api/resource/referral-programs/' + referralProgramCode);		
		return data;		
	}		
	
	async activateReferralProgram(referralProgramCode) {
		var data = await this.makePUTRequest('/api/resource/referral-programs/' + referralProgramCode + '/activate');		
		return data;		
	}
	
}



